<h2 mat-dialog-title>{{ 'orders.cancelOrder' | transloco }}</h2>
<mat-dialog-content>{{ 'orders.cancellingThisOrderWillCloseIt' | transloco }}</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close color="accent" [mat-dialog-close]="false">{{ 'common.buttons.close' | transloco }}</button>
    <span class="spacer"></span>
    <button mat-button mat-dialog-close color="warn" [mat-dialog-close]="true">{{ 'common.buttons.cancel' | transloco }}</button>
</mat-dialog-actions>